@if (label) {
  <div class="mb-2">
    <span class="font-semibold">{{ label }}</span>
  </div>
}
<form [formGroup]="searchForm">
  <div class="flex gap-4 items-center">
    <div class="flex gap-4 items-center">
      <label class="label font-semibold">
        @if (!isDefaultViewMode) {
          <span class="label is-required">*</span>
        }
        NPI: </label>
      <p-input-mask
        slotChar=""
        mask="999999999999"
        [maxlength]="12"
        formControlName="searchText"
        placeholder="Enter the NPI"
        [autoClear]="false"
      ></p-input-mask>
    </div>
    <div class="flex">
      <button
        pButton
        type="submit"
        label=" Search"
        icon="pi pi-search"
        [loading]="isLoading"
        [disabled]="!searchForm.valid"
        (click)="searchNPI()"
      ></button>

      @if(isPhysicianNotFoundView && isHhAuthForPacUser && showAddBtn) {
        <p-divider layout="vertical" />
        <button
          pButton
          type="button"
          label="Add New Provider"
          icon="pi pi-plus" 
          class="p-button p-button-secondary" 
          (click)="addNewProvider()"
          data-test-id="add-new-provider"
        ></button>
      }

      @if (displayFollowingCheckbox && !isDefaultViewMode) {
        <div class="flex gap-4 items-center ml-4">
          <label class="label font-semibold">Same as Ordering Provider:</label>
          <p-checkbox
          name="actionTaken"
          binary="true"
          [formControl]="sameAsOrderingCheck"
          ></p-checkbox>
        </div>
      }
    </div>
  </div>
  @if (isPhysicianNotFoundView || npiNotFound) {
    @if(isHhAuthForPacUser) {
      <p class="font-semibold py-2">
        {{ physicianType }} provider not found.
      </p>
      <p>
        Make sure that you have entered the correct NPI and try again.
      </p>
    } @else {
      <div class="pt-1">
        <div class="mb-4">
          <span class="physician-not-found">{{ physicianType }} Provider Not found.</span>
        </div>
        @if (!isDefaultViewMode) {
          <div class="flex items-center">
            <p-checkbox
              inputId="npiNotFoundCheck"
              binary="true"
              [formControl]="npiCheck"
            ></p-checkbox>
            <label for="npiNotFoundCheck" class="ml-2">NPI was not found. Click this checkbox and add new provider
              information below to continue</label>
          </div>
        }
      </div>
    }
  }
</form>
